import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const apiDomain = publicRuntimeConfig.apiDomain

export const uploadImageToServer = async (file: File): Promise<string> => {
  const uploadEndpoint = `${apiDomain}/api/v1/upload/img/contact-us`; // 拼接完整接口地址

  const formData = new FormData();
  formData.append("photo", file);

  const response = await fetch(uploadEndpoint, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Upload failed");
  }

  const result = await response.json();

  if (!result.data.path) {
    throw new Error("URL is missing from the returned results");
  }

  return result.data.path; // 假设返回值中包含 OSS 地址
};